import React from 'react';
import { DialogActions, Button, Box, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

import { CustomDialogModal } from '@shared/components/Dialogs';

const DialogVoucher = ({ hotelVoucher, isOpen, onClose, locator }) => {
  const pageConfiguration = useSelector(store => store.pageConfiguration);
  const theme = useTheme();

  const printVoucher = id => {
    const frameTest = document.getElementById(id);
    document.title = `Voucher - ${locator}`;
    frameTest.contentWindow.print();
    document.title =
      pageConfiguration.name + ' - ¡Vamos a darle la vuelta al mundo!';
  };

  return (
    <CustomDialogModal open={isOpen} onClose={onClose}>
      {/* Contenido del voucher */}
      <Box sx={{ width: '100%', overflow: 'hidden' }}>
        <Box
          component="iframe"
          id="voucherHtml"
          srcDoc={
            typeof hotelVoucher === 'string'
              ? hotelVoucher
              : hotelVoucher?.message || ''
          }
          style={{ border: 0 }}
          sx={{ width: '100%', height: '75vh' }}
        />
      </Box>

      {/* Botones */}
      <DialogActions sx={{ px: 2, pb: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={() => printVoucher('voucherHtml')}
          sx={{
            bgcolor: theme.primary,
            color: theme.text1,
            '&:hover': {
              bgcolor: theme.primary,
              color: theme.text1,
            },
          }}
        >
          Descargar
        </Button>

        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            bgcolor: '#fff',
            color: theme.text1,
            '&:hover': {
              bgcolor: theme.primary,
              color: theme.text1,
            },
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </CustomDialogModal>
  );
};

export default DialogVoucher;
